'use client';

import { ContextualError } from '@module/utils/error/context-error';
import * as Sentry from '@sentry/nextjs';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { getSubtitleApplyCheck } from './../../apis/client-side/subtitle/index';
import type { SubtitleApplyCheckResponse } from './../../apis/client-side/subtitle/type';
import { subtitleQueryKeys } from './../../queries/subtitle/subtitleQueryKeys';
import useGetLoginInfoQuery from '../auth/useGetLoginInfoQuery';

function SubtitlePermissionChecker() {
  const queryClient = useQueryClient();
  const { userInfo } = useGetLoginInfoQuery();

  useEffect(() => {
    if (userInfo?.isBJ !== 'Y') {
      queryClient.removeQueries({ queryKey: subtitleQueryKeys.getSubtitleApplyCheck().queryKey });
      return;
    }

    const permissionCheckData = queryClient.getQueryData(subtitleQueryKeys.getSubtitleApplyCheck().queryKey) as
      | SubtitleApplyCheckResponse
      | undefined;
    if (permissionCheckData) return;

    // 자막 신청 권한 체크 후 setQueryData
    const checkSubtitlePermission = async () => {
      try {
        const res = await getSubtitleApplyCheck();
        if (!res.canApply) return;
        queryClient.setQueryData(subtitleQueryKeys.getSubtitleApplyCheck().queryKey, res);
      } catch (err) {
        Sentry.captureException(new ContextualError('subtitle apply check failed', { err }));
      }
    };
    checkSubtitlePermission();
  }, [userInfo?.isBJ]);

  return null;
}

export default SubtitlePermissionChecker;
